import {
    FontCategory,
    FontLanguage,
    FontMood,
    DjangoFontPosture,
    FontWeight,
    FontWidth,
    FontPosture,
} from '../../constants';
import { hasOwnProperty } from '../../functions/hasOwnProperty';
import { IDjangoFontModel } from './FontModel';
import { IFontStyleModel } from './FontStyles';
import { IFoundryModel } from './Foundry';
import { IVFInfo } from './VariableFonts';

export interface IFamilySrefParams {
    familyName: string;
    foundryEESubdomain?: string;
}

export interface IDjangoFontFamily extends IDjangoFontModel {
    allow_desktop_trials: boolean;
    // canonical foundy
    canonical: number;
    canonical_series: number;
    category: FontCategory[];
    // default_style
    default_style: number;
    description: string;
    description_link: string[];
    ee_subdomain: string;
    language: FontLanguage[];
    link_only_styles: number[];
    more: string;
    mood: FontMood[];
    posture: DjangoFontPosture[];
    series: number[];
    starting_price: number;
    style: number[];
    tn_width: number[];
    tn_weight: number[];
    uploaded: string;
    weight: FontWeight[];
    width: FontWidth[];
    variable_info: IVFInfo[];
}

// Client side FontFamilyModel
export interface IFontFamilyModel extends Omit<IDjangoFontFamily, 'posture'> {
    // hydrate model properties, use diffent names that the base family.
    canonical_foundry: IFoundryModel;
    foundries: IFoundryModel[];
    def_style: IFontStyleModel;
    posture: FontPosture[];

    // @deprecated use the srefParams property instead
    getSrefParams: () => IFamilySrefParams;
    // latinized version of the name to play nice with the latin subset.
    latin_name?: string;
    // shorthand to simplify constructing links to family pages
    srefParams?: IFamilySrefParams;
}

export function isIFontFamilyModel(obj: unknown): obj is IFontFamilyModel {
    return obj != undefined && hasOwnProperty(obj, 'canonical_foundry');
}
